export type AdSize = '320x50' | '250x250' | '728x90' | '300x250';

export const AD_SRC: Record<AdSize, string> = {
  '320x50':
    'https://conteudo.jsuol.com.br/p/afiliados/adrequisitor/affiliatedAdCreative.js?source=186&caf=6bdcb975fb63421abe777924c433a224&cpg=Mzk5OTkz&idtCreatives=1364,3953_fallback&idtBanner=3953&idtUrl=399993&creative=SW5ncmVzc29zXzMyMHg1MA%3D%3D&click=',
  '250x250':
    'https://conteudo.jsuol.com.br/p/afiliados/adrequisitor/affiliatedAdCreative.js?source=186&caf=6bdcb975fb63421abe777924c433a224&cpg=Mzk5OTkz&idtCreatives=1362,3954_fallback&idtBanner=3954&idtUrl=399993&creative=SW5ncmVzc29zXzI1MHgyNTA%3D&click=',
  '728x90':
    'https://conteudo.jsuol.com.br/p/afiliados/adrequisitor/affiliatedAdCreative.js?source=186&caf=6bdcb975fb63421abe777924c433a224&cpg=Mzk5OTkz&idtCreatives=1365,3955_fallback&idtBanner=3955&idtUrl=399993&creative=SW5ncmVzc29zXzcyOHg5MA%3D%3D&click=',
  '300x250':
    'https://conteudo.jsuol.com.br/p/afiliados/adrequisitor/affiliatedAdCreative.js?source=186&caf=6bdcb975fb63421abe777924c433a224&cpg=Mzk5OTkz&idtCreatives=1363,3960_fallback&idtBanner=3960&idtUrl=399993&creative=SW5ncmVzc29zXzMwMHgyNTA%3D&click=',
};

export const AD_DIMENSIONS: Record<AdSize, { width: number; height: number }> = {
  '320x50': { width: 320, height: 50 },
  '250x250': { width: 250, height: 250 },
  '728x90': { width: 728, height: 90 },
  '300x250': { width: 300, height: 250 },
};
